var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('collapse-box',{attrs:{"collapseData":_vm.dataByProjectCategory,"spinning":_vm.spinning},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var payment = ref.record;
return [_c('payment-item',{key:payment.id,attrs:{"payment":payment,"active":_vm.activeId === payment.id},on:{"click":function($event){return _vm.viewDetail(payment)}}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }